import React, { useState, useEffect } from "react";
import cx from "classnames";
import { Option } from "react-select/lib/filters";
import { useParams } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { Select } from "@foris/avocado-suite";
import { componentQuery } from "../graphql/component.queries";
import { Component, DataQuery } from "@models/ISchema";
import { IParams } from "@models/IParams";
import { ISelectorReturn, IOption } from "./ISelectors";
import css from "./selectors.module.scss";

interface ComponentTypeSelectProps extends ISelectorReturn {
  value?: Option | null;
  menuPlacement?: "top" | "bottom";
}

const ComponentTypeSelect = (props: ComponentTypeSelectProps) => {
  const client = useApolloClient();
  const { onCallback, label, className, placeholder, value } = props;
  const { scenario }: IParams = useParams();
  const [optionsComponent, setOptionsComponent] = useState<IOption[]>([]);
  const [valueComponent, setValueComponent] = useState(value ?? null);

  const getComponentOptions = async () => {
    try {
      const response = await client.query({
        query: componentQuery,
        variables: { scenarioId: scenario },
      });
      const dataQuery: DataQuery = response?.data?.data;
      const optComponents =
        dataQuery?.components?.items?.map((component: Component) => ({
          label: component.name,
          value: component.id,
        })) ?? [];
      setOptionsComponent(optComponents);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (optionsComponent.length === 0) {
      getComponentOptions();
    }
  });

  return (
    <div className={cx(css.selectors, className)}>
      <Select
        options={optionsComponent}
        label={label}
        menuPlacement={props?.menuPlacement ?? "auto"}
        placeholder={placeholder}
        isClearable
        value={valueComponent}
        onChange={(value: IOption) => {
          if (value) {
            setValueComponent(value as Option);
            onCallback(value);
          } else {
            setValueComponent(null);
            onCallback(value);
          }
        }}
      />
    </div>
  );
};

export default ComponentTypeSelect;
